export default "__VITE_ASSET__DgZDDYVq__"